export default "__VITE_ASSET___vlsHR31__"